import axios from "axios";

const API_BASE =
    process.env.REACT_APP_API_URL || "https://localhost:7231";

axios.defaults.withCredentials = true;

export async function createAndQueueProject(payload) {
    const response = await axios.post(
        `${API_BASE}/api/website/generate`,
        payload,
        { withCredentials: true }
    );
    return response.data;
}

export async function createAndQueuePreviewSession(payload) {
    const response = await axios.post(
        `${API_BASE}/api/website/preview-generate`,
        payload,
        { withCredentials: true }
    );
    return response.data;
}

export async function getPreview(projectId, variantKey = null) {
    const query = variantKey ? `?variantKey=${encodeURIComponent(variantKey)}` : "";
    const response = await axios.get(
        `${API_BASE}/api/website/${projectId}/preview${query}`,
        { withCredentials: true }
    );
    return response.data;
}

export async function getPreviewSession(previewSessionId, variantKey = null) {
    const query = variantKey ? `?variantKey=${encodeURIComponent(variantKey)}` : "";
    const response = await axios.get(
        `${API_BASE}/api/website/preview-session/${previewSessionId}${query}`,
        { withCredentials: true }
    );
    return response.data;
}

export async function getPreviewSessionStatus(previewSessionId) {
    const response = await axios.get(
        `${API_BASE}/api/website/preview-session/${previewSessionId}/status`,
        { withCredentials: true }
    );
    return response.data;
}

export async function claimPreviewSession(previewSessionId) {
    const response = await axios.post(
        `${API_BASE}/api/website/preview-session/${previewSessionId}/claim`,
        {},
        { withCredentials: true }
    );
    return response.data;
}

export async function publishProject(projectId) {
    const response = await axios.post(
        `${API_BASE}/api/website/${projectId}/publish`,
        {},
        { withCredentials: true }
    );
    return response.data;
}

export async function regenerateProject(projectId, payload = {}) {
    const response = await axios.post(
        `${API_BASE}/api/website/${projectId}/regenerate`,
        payload,
        { withCredentials: true }
    );
    return response.data;
}

export async function autofillWebsiteForm(payload) {
    const response = await axios.post(
        `${API_BASE}/api/website/autofill`,
        payload,
        { withCredentials: true }
    );
    return response.data;
}

export async function getThemes() {
    const response = await axios.get(
        `${API_BASE}/api/website/themes`,
        { withCredentials: true }
    );
    return response.data;
}